import React, {useMemo} from 'react'

const ConditionalComponent = ({conditions}) => {
  // Use useMemo to memoize the matched component
  const matchedComponent = useMemo(() => {
    return conditions.find(({condition}) => condition)
  }, [conditions])

  // If a matched condition is found, render its corresponding component
  if (matchedComponent) {
    const {component: Component} = matchedComponent
    return <Component />
  }

  // If no condition is matched, render null or fallback UI
  return null
}

export default ConditionalComponent
